import React from "react";
import { ErrorMessage } from "formik";

const ErrorM: React.FC<{ name: string }> = props => (
  <ErrorMessage name={props.name}>
    {msg =>
      typeof msg === "string" ? (
        <div className="ErrorLabel">{msg}</div>
      ) : (
        <div></div>
      )
    }
  </ErrorMessage>
);

export { ErrorM };
